<template>
  <i-modal
    class="modal-search-railway"
    v-model="modal"
    @on-visible-change="onVisibleChange"
    title="沿線検索"
    width="600"
    footer-hide
  >
    <div>
      <i-tab :value="tabValue" @on-click="onClickSettingTab">
        <!--エリア選択タブ-->
        <i-tab-panel label="エリア選択" name="pref">
          <div v-if="prefLoading" class="loading-container">
            <i-spin fix />
          </div>
          <div v-else class="list_wrap">
            <template v-for="(areaItem, areaIndex) in prefs">
              <i-button
                :key="areaIndex"
                type="primary"
                shape="circle"
                size="small"
                @click="onClickArea(areaItem.pref_cd)"
                :ghost="selected.prefs.indexOf(areaItem.pref_cd) === -1"
                style="margin-bottom: 4px; margin-right: 4px;"
              >
                {{ areaItem.pref_name }}
              </i-button>
            </template>
          </div>
          <div class="btn_wrap">
            <i-button style="margin-right: 8px;" @click="onClickCancel">
              キャンセル
            </i-button>
            <i-button type="primary" :disabled="!selected.prefs.length" @click="onClickSearchLine">
              沿線を絞り込み
            </i-button>
          </div>
        </i-tab-panel>

        <!--沿線選択タブ-->
        <i-tab-panel label="沿線選択" :disabled="tabDisabledLine" name="line">
          <div v-if="lineLoading" class="loading-container">
            <i-spin fix />
          </div>
          <template v-else>
            <div style="padding-bottom: 16px;">
              <i-input
                v-model="inputSuggestLine"
                size="small"
                search
                @on-keyup="onKeyupSuggestLine"
                @on-keydown="onKeydownSuggestLine"
                style="width: 200px;"
              />
              <transition>
                <span class="suggest-spin-col" v-show="loadingSuggestLine">
                  <i-spin>
                    <i-icon type="ios-loading" size="14" class="suggest-spin-icon-load" />
                  </i-spin>
                </span>
              </transition>
            </div>
            <div class="list_wrap">
              <template v-for="(lineArray, lineIndex) in lines">
                <i-checkbox-group :key="lineIndex" v-model="selected.lines" style="margin-bottom: 16px;">
                  <div class="parent_name">{{ lineArray.pref_name }}</div>
                  <div v-if="lineArray.displayText" class="no_data">
                    条件に一致する沿線がありません。
                  </div>
                  <template v-for="(item, itemIndex) in lineArray.line">
                    <span v-if="!item.hidden" :key="itemIndex" class="checkbox_wrap">
                      <i-checkbox :label="item.line_cd + '_' + item.line_name">
                        {{ item.line_name }}
                      </i-checkbox>
                    </span>
                  </template>
                </i-checkbox-group>
              </template>
            </div>
          </template>
          <div class="btn_wrap">
            <i-button style="margin-right: 8px;" @click="onClickCancel">
              キャンセル
            </i-button>
            <i-button
              type="primary"
              style="margin-right: 8px;"
              :disabled="selected.lines.length === 0"
              @click="onClickSearch"
            >
              選択沿線の全物件を表示
            </i-button>
            <i-button type="primary" :disabled="selected.lines.length === 0" @click="onClickSearchStation">
              駅を絞り込む
            </i-button>
          </div>
        </i-tab-panel>

        <!--駅選択タブ-->
        <i-tab-panel label="駅選択" :disabled="tabDisabledStation" name="station">
          <div v-if="stationLoading" class="loading-container">
            <i-spin fix />
          </div>
          <template v-else>
            <div style="padding-bottom: 16px;">
              <i-input
                size="small"
                search
                style="width: 200px;"
                v-model="inputSuggestStation"
                @on-keyup="onKeyupSuggestStation"
                @on-keydown="onKeydownSuggestStation"
              />
              <transition>
                <span class="suggest-spin-col" v-show="loadingSuggestStation">
                  <i-spin>
                    <i-icon type="ios-loading" size="14" class="suggest-spin-icon-load" />
                  </i-spin>
                </span>
              </transition>
            </div>
            <div class="list_wrap">
              <template v-for="(stationArray, stationIndex) in stations">
                <i-checkbox-group :key="stationIndex" v-model="selected.stations" style="margin-bottom: 16px;">
                  <div class="parent_name">{{ stationArray.line_name }}</div>
                  <div v-if="stationArray.displayText" class="no_data">
                    条件に一致する駅がありません。
                  </div>
                  <template v-for="(item, itemIndex) in stationArray.station">
                    <span v-if="!item.hidden" :key="itemIndex" class="checkbox_wrap">
                      <i-checkbox :label="`${item.line_cd}-${item.station_cd}`">
                        {{ item.station_name }}
                      </i-checkbox>
                    </span>
                  </template>
                </i-checkbox-group>
              </template>
            </div>
          </template>
          <div class="btn_wrap">
            <i-button style="margin-right: 8px;" @click="onClickCancel">
              キャンセル
            </i-button>
            <i-button type="primary" :disabled="selected.stations.length === 0" @click="onClickSearch">
              絞り込み
            </i-button>
          </div>
        </i-tab-panel>
      </i-tab>
    </div>
  </i-modal>
</template>

<script>
import _ from 'lodash'
import { Modal, Button, Input, CheckboxGroup, Checkbox, Tabs, TabPane, Spin, Icon } from 'view-design'
import AddressRepository from '@/repositories/addressRepository.js'
import TrainRepository from '@/repositories/trainRepository.js'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-input': Input,
    'i-checkbox-group': CheckboxGroup,
    'i-checkbox': Checkbox,
    'i-tab': Tabs,
    'i-tab-panel': TabPane,
    'i-spin': Spin,
    'i-icon': Icon,
  },
  data() {
    return {
      prefLoading: false,
      lineLoading: false,
      stationLoading: false,
      tabValue: 'pref',
      prefs: [],
      lines: [],
      stations: [],
      selected: {
        prefs: [],
        lines: [],
        stations: [],
      },
      requestParams: {
        pref_cds: null,
        cds: null,
      },
      inputSuggestLine: '',
      loadingSuggestLine: false,
      inputSuggestStation: '',
      loadingSuggestStation: false,
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalSearchByRailway/getModal']
      },
      set(val) {
        this.$store.commit('ModalSearchByRailway/setModal', val)
      },
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    tabDisabledLine() {
      return this.tabValue === 'pref' ? true : false
    },
    tabDisabledStation() {
      return this.tabValue === 'station' ? false : true
    },
  },
  methods: {
    // モーダル開閉時処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // モーダル起動処理
        this.tabValue = 'pref'
        this.getPrefs()
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    // 都道府県取得処理
    async getPrefs() {
      this.modalLoading = true
      await AddressRepository.getPrefs(true)
        .then(data => {
          if (data.result) {
            this.prefs = data.data
          }
        })
        .catch(e => {
          console.log(e)
          alert('エリアの取得に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // 沿線 サジェスト
    onKeyupSuggestLine: _.debounce(function() {
      let line = this.lines
      let suggestLine = []
      let suggestText = this.inputSuggestLine
      _.forEach(line, function(value) {
        let displayText = true
        let obj = {
          pref_name: value.pref_name,
          line: [],
        }
        _.forEach(value.line, function(v) {
          if (v.line_name.indexOf(suggestText) != -1) {
            v.hidden = false
            displayText = false
          } else {
            v.hidden = true
          }
          obj.line.push(v)
        })
        obj.displayText = displayText
        suggestLine.push(obj)
      })

      this.lines = suggestLine
      this.loadingSuggestLine = false
    }, 1000 * 1),
    onKeydownSuggestLine() {
      this.loadingSuggestLine = true
    },
    // 駅 サジェスト
    onKeyupSuggestStation: _.debounce(function() {
      let station = this.stations
      let suggestStation = []
      let suggestText = this.inputSuggestStation
      _.forEach(station, function(value) {
        let displayText = true
        let obj = {
          line_name: value.line_name,
          station: [],
        }
        _.forEach(value.station, function(v) {
          if (v.station_name.indexOf(suggestText) != -1) {
            v.hidden = false
            displayText = false
          } else {
            v.hidden = true
          }
          obj.station.push(v)
        })
        obj.displayText = displayText
        suggestStation.push(obj)
      })

      this.stations = suggestStation
      this.loadingSuggestStation = false
    }, 1000 * 1),
    onKeydownSuggestStation() {
      this.loadingSuggestStation = true
    },
    // モーダル キャンセル時の処理
    onClickCancel() {
      this.modal = false
    },
    /* タブクリック時の処理 */
    onClickSettingTab(ev) {
      if (ev === 'pref') {
        this.lines = []
        this.stations = []
        this.selected.lines = []
        this.selected.stations = []
      } else if (ev === 'line') {
        this.stations = []
        this.selected.stations = []
      }
      this.tabValue = ev
    },
    // エリアボタンクリック時の処理
    onClickArea(cd) {
      let selectIdx = this.selected.prefs.indexOf(cd)
      if (selectIdx === -1) {
        this.selected.prefs.push(cd)
      } else {
        this.selected.prefs.splice(selectIdx, 1)
      }
    },
    // 沿線を絞り込みボタンがクリックされたときの処理
    async onClickSearchLine() {
      this.prefLoading = true
      this.lineLoading = true
      const prefCds = this.selected.prefs
      await TrainRepository.getLines(prefCds)
        .then(data => {
          if (data.result) {
            let result = _.chain(data.data)
              .groupBy('pref_name')
              .toPairs()
              .map(function(currentItem) {
                return _.zipObject(['pref_name', 'line'], currentItem)
              })
              .value()
            this.lines = result
          }
        })
        .catch(e => {
          console.log(e)
          alert('データの取得に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.prefLoading = false
          this.lineLoading = false
          this.inputSuggestLine = ''
          this.loadingSuggestLine = false
          this.tabValue = 'line'
        })
    },
    // 駅を絞り込みボタンがクリックされたときの処理
    async onClickSearchStation() {
      this.lineLoading = true
      this.stationLoading = true
      const lineCdNames = this.selected.lines
      const prefCds = this.selected.prefs
      let lineCds = []
      let lineNames = []
      // 沿線コード + 沿線名の分離（ex. lineCdNames: 2_101_JR宇都宮線）
      _.forEach(lineCdNames, val => {
        if (val) {
          const match = val.match(/^(\d{1}-\d{3})_(.+)$/)
          if (match) {
            lineCds.push(match[1]) // ex. 2-101
            lineNames.push(match[2]) // ex. JR宇都宮線
          }
        }
      })
      await TrainRepository.getStations(lineCds, prefCds, lineNames)
        .then(data => {
          if (data.result) {
            let result = _.chain(data.data)
              .groupBy('line_name')
              .map((stations, lineName) => {
                // 沿線名でグループ化した後、駅名をユニーク化
                const uniqueStations = _.uniqBy(stations, 'station_name')
                return {
                  line_name: lineName,
                  station: uniqueStations
                }
              })
              .value()
            this.stations = result
          }
        })
        .catch(e => {
          console.log(e)
          alert('データの取得に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.stationLoading = false
          this.lineLoading = false
          this.inputSuggestStation = ''
          this.loadingSuggestStation = false
          this.tabValue = 'station'
        })
    },
    // 絞り込み実行
    onClickSearch() {
      this.search.railway_cds =
        this.selected.stations.length !== 0
          ? this.formatValue(this.selected.stations, 'station')
          : this.formatValue(this.selected.lines, 'line_cd')
      this.search.railway_names =
        this.selected.stations.length !== 0
          ? ''
          : this.formatValue(this.selected.lines, 'line_name')
      this.$emit('search')
      this.modal = false
    },
    // 沿線コード配列を送信用パラメータにフォーマット
    formatValue(arr, type) {
      if (type === 'line_cd' || type === 'line_name') {
        let tmp = []
        _.forEach(arr, val => {
          if (val) {
            const match = val.match(/^(\d{1}-\d{3})_(.+)$/)
            if (match && type === 'line_cd') {
              tmp.push(match[1]) // ex. 2-101
            } else if (match && type === 'line_name') {
              tmp.push(match[2]) // ex. JR宇都宮線
            }
          }
        })
        arr = tmp
      }
      return arr.join(',')
    },
    // パラメータリセット
    resetParams() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      // パラメータリセット
      this.prefs = []
      this.lines = []
      this.stations = []
      this.selected.prefs = []
      this.selected.lines = []
      this.selected.stations = []
      this.requestParams.pref_cds = null
      this.requestParams.cds = null
      this.inputSuggestLine = ''
      this.loadingSuggestLine = false
      this.inputSuggestStation = ''
      this.loadingSuggestStation = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-search-railway {
  .list_wrap {
    max-height: 250px;
    overflow: scroll;
  }
  .btn_wrap {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .parent_name {
    font-weight: bold;
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 4px;
    margin-bottom: 8px;
  }
  .checkbox_wrap {
    min-width: 120px;
    display: inline-block;
    margin-bottom: 8px;
    margin-right: 8px;
  }
  .no_data {
    font-size: 12px;
    margin: 16px 0;
  }
}
.loading-container {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}

.suggest-spin {
  &-col {
    display: inline-block;
    margin-left: 8px;
  }
  &-icon-load {
    animation: suggest-spin 1s linear infinite;
  }
}

@keyframes suggest-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
